import BaseView from './components/Base';

export { default as BaseView } from './components/Base';
export { default as FormContentView } from './components/FormContent';
export { MovementForm } from './components/FormContent';

export default BaseView;